<template>
  <div>
    <label
      class="checkbox"
    >
      <input
        type="checkbox"
        v-model="confirmed"
        :value="true"
      />
      true
    </label>
    <label
      class="checkbox"
    >
      <input
        type="checkbox"
        v-model="confirmed"
        :value="false"
      />
      false
    </label>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ConfirmedInput extends Vue {
  @Prop() value!: boolean[]

  private get confirmed(): boolean[] {
    return this.value
  }

  private set confirmed(confirmed: boolean[]) {
    this.$emit('input', confirmed)
  }
}
</script>

<style scoped>
input[type="checkbox"] {
  margin-right:8px;
}
.checkbox {
  margin-right:20px;
}
</style>
